import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Modal from 'react-modal'
import {ResponsiveLine} from '@nivo/line';

const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };
class TableroProgreso extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valSearch: '',
      findProducts: true,
      point: {},
    }
  }

  componentDidMount() {
    // this.props.onLoadInfoByGraph()
  }

  render() {

    const { isLoading, point, } = this.state
    const { filterBy, dataBar, } = this.props.mainState

    if(isLoading) {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 0, }}>
          <p>Cargando...</p>
        </div>
      )
    }

    return (
      <div style={{height:450, width:'100%'}}>
        {
          point.x ? (
            <>
              <b>Información</b>
              <p>Concepto: {point.data.label}</p>
              <p>Valor: ${ this.number_format(point.data.y,2) }</p>
            </>
          ) : null
        }

        <ResponsiveLine
          data={dataBar}
          margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
          yFormat=" >-.2f"
          curve="monotoneX"
          axisTop={null}
          axisRight={null}
          tooltip={(point) => {
            this.setState(point)
            return null
          }}
          axisBottom={{
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Meses',
            legendOffset: 36,
            legendPosition: 'middle'
          }}
          axisLeft={{
              orient: 'left',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'Total',
              legendOffset: -40,
              legendPosition: 'middle'
          }}
          colors= {["#e74c3c","#e67e22","#f1c40f","#9b59b6","#2ecc71",]}
          enableGridX={false}
          lineWidth={3}
          // enablePoints={false}
          // pointSize={4}
          pointColor={{ theme: 'background' }}
          // pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabelYOffset={-12}
          useMesh={true}
        />
      </div>
    )
  }

  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getStyleModal(opt) {
    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

 getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }


}

export default withRouter(TableroProgreso)